export default "__VITE_ASSET__Iur8Tp$p__"